import { StructuredText, Image } from 'react-datocms';
import { Document } from 'datocms-structured-text-utils';
import { ReferralTypeInvalidFragment } from '@/utils/dato/generated';
import { customNodeRules, renderBlock } from '@/components/structuredText';

const ReferralTypeInvalid = ({ primaryContent, image }: ReferralTypeInvalidFragment) => (
  <div className="max-w-[540px] md:max-w-[720px] md:min-h-[200px] lg:max-w-[960px] xl:max-w-[1224px] px-5 mx-auto pt-6 lg:pt-8">
    <div className="clearfix">
      <div className="display-heading clearfix -mx-4">
        <div className="[&_img]:max-md:object-cover px-4 h-auto max-md:rounded-xl [&>div]:max-md:h-full max-md:overflow-hidden max-lg:max-w-[430px] lg:w-[45%] mx-auto max-lg:mb-6 relative z-[4] lg:float-right">
          <Image data={image?.responsiveImage} className="mx-auto!" priority />
        </div>
        <div className="lg:w-[55%] lg:float-left px-4 mb-6 xl:mb-0">
          <StructuredText
            data={{ value: primaryContent?.value as Document, blocks: primaryContent?.blocks }}
            customNodeRules={customNodeRules}
            renderBlock={renderBlock}
          />
        </div>
      </div>
    </div>
  </div>
);

export default ReferralTypeInvalid;
